// Monogramme aux couleurs de la marque. Pour de vrais logos : deposer
// public/banks/<code>.svg et le rendre ici (code : voir BankSeed.cs).

interface Brand {
  short: string
  background: string
  foreground: string
}

const brands: Record<string, Brand> = {
  'bnp-paribas': { short: 'BNP', background: '#00915A', foreground: '#FFFFFF' },
  'societe-generale': { short: 'SG', background: '#E60028', foreground: '#FFFFFF' },
  'credit-agricole': { short: 'CA', background: '#007A6C', foreground: '#FFFFFF' },
  'credit-mutuel': { short: 'CM', background: '#1D3F8F', foreground: '#FFFFFF' },
  cic: { short: 'CIC', background: '#0B3F8C', foreground: '#FFFFFF' },
  lcl: { short: 'LCL', background: '#12275C', foreground: '#FFD200' },
  'la-banque-postale': { short: 'LBP', background: '#FFD500', foreground: '#12275C' },
  'caisse-epargne': { short: 'CE', background: '#D6001C', foreground: '#FFFFFF' },
  'banque-populaire': { short: 'BP', background: '#0B3C8C', foreground: '#FFFFFF' },
  boursobank: { short: 'BB', background: '#D1006F', foreground: '#FFFFFF' },
  'hello-bank': { short: 'hb!', background: '#00A3D9', foreground: '#FFFFFF' },
  fortuneo: { short: 'F', background: '#1F2A1F', foreground: '#8DC63F' },
  bforbank: { short: 'BfB', background: '#2B1A4A', foreground: '#FFFFFF' },
  monabanq: { short: 'M', background: '#6B2C91', foreground: '#FFFFFF' },
  ccf: { short: 'CCF', background: '#1A1A1A', foreground: '#FFFFFF' },
  'credit-cooperatif': { short: 'CC', background: '#E2001A', foreground: '#FFFFFF' },
  'banque-palatine': { short: 'P', background: '#7A1F3D', foreground: '#FFFFFF' },
  nickel: { short: 'N', background: '#111111', foreground: '#FFFFFF' },
  revolut: { short: 'R', background: '#191C1F', foreground: '#FFFFFF' },
  n26: { short: 'N26', background: '#36A18B', foreground: '#FFFFFF' },
  qonto: { short: 'Q', background: '#1D1D1B', foreground: '#FFFFFF' },
  shine: { short: 'S', background: '#FFB800', foreground: '#1A1A1A' },
  wise: { short: 'W', background: '#9FE870', foreground: '#163300' },
  'trade-republic': { short: 'TR', background: '#000000', foreground: '#FFFFFF' },
}

function initials(name: string): string {
  const words = name
    .split(/[\s'’-]+/)
    .filter((word) => word.length > 0 && !['de', 'du', 'des', 'la', 'le', 'les', 'd'].includes(word.toLowerCase()))

  const letters = words.slice(0, 2).map((word) => word[0]!.toUpperCase())
  return letters.length > 0 ? letters.join('') : '?'
}

function brandOf(bank: { name: string; code: string | null }): Brand {
  return (bank.code !== null ? brands[bank.code] : undefined) ?? {
    short: initials(bank.name),
    background: '#737373',
    foreground: '#FFFFFF',
  }
}

export default function BankIcon({
  bank,
  size = 'md',
}: {
  bank: { name: string; code: string | null }
  size?: 'sm' | 'md' | 'lg'
}) {
  const brand = brandOf(bank)
  const dimensions = {
    sm: 'h-8 w-8 rounded-lg text-[10px]',
    md: 'h-10 w-10 rounded-xl text-xs',
    lg: 'h-12 w-12 rounded-xl text-sm',
  }[size]

  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 select-none items-center justify-center font-bold tracking-tight ${dimensions}`}
      style={{ backgroundColor: brand.background, color: brand.foreground }}
    >
      {brand.short}
    </span>
  )
}
